import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowUpRight } from 'lucide-react';

const closesLabel = (iso) => new Date(iso).toLocaleString([], { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

export const SportMarketRow = ({ market }) => {
  const yes = market.prices?.YES_price_formatted || `${market.yes_price ?? 50}%`;
  return (
    <li className="group flex flex-wrap items-center justify-between gap-3 py-4 border-b border-[#1e2a45] last:border-0" data-testid={`sport-market-${market.id}`}>
      <div className="min-w-0 flex-1">
        <div className="text-sm sm:text-base text-white">{market.title}</div>
        <div className="mt-1 flex items-center gap-1.5 text-xs text-gray-500">
          <Clock className="h-3.5 w-3.5" />Starts {closesLabel(market.closes_at)}
          {market.league && <span className="truncate">· {market.league}</span>}
        </div>
      </div>
      <div className="flex items-center gap-4">
        <span className="text-sm tabular-nums text-gray-300">YES <span className="text-white font-semibold">{yes}</span></span>
        <Link
          to={`/?market=${market.id}`}
          data-testid={`sport-market-trade-${market.id}`}
          className="inline-flex items-center gap-1 rounded-full bg-[#3B82F6] px-3.5 py-1.5 text-xs font-medium text-white hover:bg-[#2563EB] transition-colors"
        >
          Trade <ArrowUpRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </li>
  );
};

export default SportMarketRow;
